import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined"
import Chip from "@mui/material/Chip"
import { styled } from "@mui/material/styles"

export default function CheckableChip({
  label,
  checked,
  onChecked,
  onUnchecked,
}) {
  return checked ? (
    <CheckedChip label={label} onClick={onUnchecked} />
  ) : (
    <PerkChip label={label} onClick={onChecked} />
  )
}

const PerkChip = styled(Chip)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.colors.lightBackground,
  cursor: "pointer",
  "&:hover": {
    backgroundColor: theme.palette.colors.dimLightBackground,
  },
}))

const ActivePerkChip = styled(PerkChip)(({ theme }) => ({
  backgroundColor: theme.palette.primary.light,
  color: theme.palette.primary.contrastText,
  "& .MuiChip-label": { display: "flex", alignItems: "center" },
  "&:hover": {
    backgroundColor: theme.palette.primary.dark,
  },
}))

export function CheckedChip({ label, onClick }) {
  return (
    <ActivePerkChip
      label={
        <>
          {label}{" "}
          <CheckOutlinedIcon
            sx={{ ml: 1, fontSize: "1.25em", color: "white" }}
          />
        </>
      }
      onClick={onClick}
    />
  )
}
